<template>
  <v-row v-if="loading" justify="center" align="center" style="height: 80vh">
    <v-col cols="12" class="text-center">
      <v-progress-circular size="80" width="5" color="primary" indeterminate></v-progress-circular>
      <div class="mt-4 text-h6">Cargando...</div>
    </v-col>
  </v-row>
  <div v-else>
    <v-card v-for="(question, index) in questions" :key="index" class="ma-4" width="100vw">
      <v-card-title class="d-flex align-start flex-column primary white--text">
        <div class="d-flex justify-space-between w-100">
          <div class="d-flex text-justify ">
            <span>{{ index + 1 }}) : {{ question.question.title }}</span> 
          </div>
          <div class="mx-2 d-flex align-center">
            <v-chip class="mr-2" color="white" text-color="primary">
              {{ calculateScore(question, index) }} pts
            </v-chip>
            <v-chip color="white" text-color="primary">
              <v-icon left>mdi-clock-outline</v-icon>
              {{ formatTime(getTimeFromId(question.question.id)) }}
            </v-chip>
          </div>
        </div>
        
        <div v-if="question.question.description && question.question.description.length > 0" 
            class="mt-2 w-100 description-content text-left">
          {{ question.question.description }}
        </div>
      </v-card-title>
      <!-- Preguntas de desarrollo (tipo 0) -->
      <v-container class="pa-5" fluid v-if="question.question.type === 0">
        <div v-if="isAnswerNull(index)" >
          <v-alert class="pa-3 warning lighten-4" dense>
            No se respondió esta pregunta
          </v-alert>
        </div>
        <div v-else disabled class="light-blue lighten-4" color="teal">
          <p class="pa-5" text-color="primary">
            Respuesta: {{ getAnswerText(index) }}
          </p>
        </div>
        
        <!-- Mostrar evaluación AI si existe
        <v-card 
          v-if="!isAnswerNull(index) && hasAIScore(index)"
          class="mt-3 pa-3"
          outlined
        >
          <v-card-title class="subtitle-1">
            Evaluación automatizada: {{ getAIScore(index) }}/{{ question.question.points }} pts
          </v-card-title>
          <v-card-text v-if="getAIExplanation(index)">
            {{ getAIExplanation(index) }}
          </v-card-text>
        </v-card> -->
        
      </v-container>

      <!-- Preguntas de selección única (tipo 1) -->
      <v-container class="pa-5" fluid v-if="question.question.type === 1">
        <div v-if="isAnswerNull(index)" >
          <v-alert class="pa-3 warning lighten-4" dense>
            No se respondió esta pregunta
          </v-alert>
        </div>
        <v-radio-group v-else>
          <v-radio disabled v-for="(alternative, i) in question.question.answer" :key="i" color="red"
            :off-icon="getIcon(alternative, getAnswerObject(index))">
            <template v-slot:label>
              <h4 v-if="
                isAnswerEqualToAlternative(index, alternative) &&
                alternative.isCorrect
              " class="text-left" style="color: green">
                {{ alternative.description }} (Respuesta correcta)
              </h4>
              <h4 v-else-if="
                isAnswerEqualToAlternative(index, alternative) &&
                !alternative.isCorrect
              " class="text-left" style="color: red">
                {{ alternative.description }}
              </h4>
              <h4 v-else class="text-left"
                :style="{ color: alternative.isCorrect ? 'green' : '' }">
                {{ alternative.isCorrect
                   ? `${alternative.description} (Respuesta correcta)`
                   : alternative.description 
                }}
              </h4>
            </template>
          </v-radio>
        </v-radio-group>
      </v-container>

      <!-- Preguntas de selección múltiple (tipo 2) -->
      <v-container class="pa-5" fluid v-if="question.question.type === 2">
        <div v-if="isAnswerNull(index)" >
          <v-alert class="pa-3 warning lighten-4" dense>
            No se respondió esta pregunta
          </v-alert>
        </div>
        <v-checkbox v-else disabled v-for="(alternative, i) in question.question.answer" :key="i"
          :label="alternative.description" :value="alternative"
          :off-icon="getIconMultiple(alternative, questionAnswers[index])">
          <template v-slot:label>
            <h4 v-if="
              isOptionSelected(index, alternative.id) && 
              alternative.isCorrect
            " class="text-left" style="color: green">
              {{ alternative.description }} (Respuesta Correcta)
            </h4>
            <h4 v-else-if="
              isOptionSelected(index, alternative.id) && 
              !alternative.isCorrect
            " class="text-left" style="color: red">
              {{ alternative.description }}
            </h4>
            <h4 v-else class="text-left" :style="{ color: alternative.isCorrect ? 'green' : '' }">
              {{
              alternative.isCorrect
              ? `${alternative.description} (Respuesta correcta)`
              : alternative.description
              }}
            </h4>
          </template>
        </v-checkbox>
      </v-container>
    </v-card>
    <v-card v-if="questions.length === 0">
      Texto no posee actividad.
    </v-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["timeAnswer"],
  data() {
    return {
      questionAnswers: null,
      reply: null,
      questions: [],
      time: "",
      loading: null,
    };
  },
  methods: {
    // Verifica si la respuesta es nula
    isAnswerNull(index) {
      try {
        return !this.questionAnswers || 
               !this.questionAnswers[index] || 
               this.questionAnswers[index].answer === null;
      } catch (e) {
        console.error('Error al verificar respuesta nula:', e);
        return true;
      }
    },
    
    // Obtiene el texto de la respuesta para preguntas de desarrollo
    getAnswerText(index) {
      try {
        if (this.isAnswerNull(index)) return 'No respondido';
        
        const answer = this.questionAnswers[index].answer;
        if (typeof answer === 'string') return answer;
        if (typeof answer === 'object' && answer.description) return answer.description;
        
        return JSON.stringify(answer);
      } catch (e) {
        console.error('Error al obtener texto de respuesta:', e);
        return 'Error al cargar respuesta';
      }
    },
    
    // Verifica si la respuesta tiene puntuación AI
    /*hasAIScore(index) {
      try {
        return this.questionAnswers[index] && 
               this.questionAnswers[index].aiScore !== undefined;
      } catch (e) {
        return false;
      }
    },
    
    // Obtiene la puntuación AI
    getAIScore(index) {
      try {
        return this.questionAnswers[index].aiScore;
      } catch (e) {
        return 0;
      }
    },
    
    // Obtiene la explicación AI
    getAIExplanation(index) {
      try {
        return this.questionAnswers[index].explanation || '';
      } catch (e) {
        return '';
      }
    }*/
    
    formatTime(seconds) {
        if (!seconds || seconds < 0) return 'N/A';

        const totalSeconds = Math.floor(seconds); // Redondear correctamente
        const minutes = Math.floor(totalSeconds / 60);
        const remainingSeconds = totalSeconds % 60;

        return minutes > 0
        ? `${minutes}m${remainingSeconds}s`
        : `${remainingSeconds}s`;
      },
    // Obtiene el objeto de respuesta para tipo 1
    getAnswerObject(index) {
      try {
        if (this.isAnswerNull(index)) return { id: null, isCorrect: false };
        return this.questionAnswers[index].answer || { id: null, isCorrect: false };
      } catch (e) {
        console.error('Error al obtener objeto de respuesta:', e);
        return { id: null, isCorrect: false };
      }
    },
    
    // Verifica si la respuesta seleccionada es igual a la alternativa
    isAnswerEqualToAlternative(index, alternative) {
      try {
        if (this.isAnswerNull(index)) return false;
        
        const answer = this.questionAnswers[index].answer;
        return answer && answer.id === alternative.id;
      } catch (e) {
        console.error('Error al comparar respuesta con alternativa:', e);
        return false;
      }
    },
    
    // Verifica si una opción está seleccionada en respuestas múltiples
    isOptionSelected(index, alternativeId) {
      try {
        if (this.isAnswerNull(index)) return false;
        
        const answers = this.questionAnswers[index].answer;
        if (!Array.isArray(answers)) return false;
        
        return answers.some(answer => answer.id === alternativeId);
      } catch (e) {
        console.error('Error al verificar opción seleccionada:', e);
        return false;
      }
    },
    
    findReply({ idQuestion }) {
      try {
        if (!this.reply) return { answer: { id: null, isCorrect: false } };
        
        const reply = this.reply.find(el => el.idQuestion === idQuestion);
        return reply || { answer: { id: null, isCorrect: false } };
      } catch (e) {
        console.error('Error en findReply:', e);
        return { answer: { id: null, isCorrect: false } };
      }
    },
    
    getIcon(alternative, answer) {
      try {
        if (!answer || answer.id === null) return "mdi-checkbox-blank-circle-outline";
        
        if (alternative.id === answer.id && alternative.isCorrect) {
          return "mdi-check-circle";
        }
        if (alternative.id === answer.id && !alternative.isCorrect) {
          return "mdi-close-circle";
        }
        return "mdi-checkbox-blank-circle-outline";
      } catch (e) {
        console.error('Error en getIcon:', e);
        return "mdi-checkbox-blank-circle-outline";
      }
    },
    
    getTimeFromId(id) {
      try {
        if (!this.timeAnswer || !Array.isArray(this.timeAnswer)) return '0.00';
        
        // Encontrar el objeto en timeAnswer que tenga el id coincidente
        const timeObj = this.timeAnswer.find(val => val.id === id);
        if (!timeObj) return '0.00';
        
        const time = parseFloat(timeObj.time);
        return isNaN(time) ? '0.00' : time.toFixed(2);
      } catch (error) {
        console.error('Error al analizar tiempo:', error);
        return '0.00'; // Valor predeterminado en caso de error
      }
    },
    
    getIconMultiple(alternative, answer) {
      try {
        if (!answer || !answer.answer || !Array.isArray(answer.answer)) {
          return "mdi-checkbox-blank-outline";
        }
        
        if (
          answer.answer.some((val) => val.id === alternative.id) &&
          alternative.isCorrect
        ) {
          return "mdi-checkbox-marked";
        }
        if (
          answer.answer.some((val) => val.id === alternative.id) &&
          !alternative.isCorrect
        ) {
          return "mdi-close-box";
        }
        return "mdi-checkbox-blank-outline";
      } catch (e) {
        console.error('Error en getIconMultiple:', e);
        return "mdi-checkbox-blank-outline";
      }
    },
    
    calculateScore(question, index) {
      try {
        // Si no hay respuesta, el puntaje es 0
        if (this.isAnswerNull(index)) {
          return `0/${question.question.points}`;
        }
        
        // Preguntas de desarrollo con evaluación AI
        if (question.question.type === 0 && this.hasAIScore(index)) {
          const score = this.getAIScore(index);
          return `${score}/${question.question.points}`;
        }
        
        // Preguntas de selección múltiple (tipo 2)
        if (question.question.type === 2) {
          const correctAnswers = question.question.answer.filter(a => a.isCorrect);
          const studentAnswers = this.questionAnswers[index].answer;
          
          // Verificar que studentAnswers sea un array
          if (!Array.isArray(studentAnswers)) {
            return `0/${question.question.points}`;
          }
          
          // Verificar que todas las respuestas correctas estén seleccionadas
          const allCorrect = correctAnswers.every(correctAnswer => 
            studentAnswers.some(studentAnswer => 
              studentAnswer.id === correctAnswer.id && studentAnswer.isCorrect
            )
          );
          
          // Verificar que no haya respuestas incorrectas seleccionadas
          const noIncorrect = !studentAnswers.some(studentAnswer => !studentAnswer.isCorrect);
          
          return (allCorrect && noIncorrect) ? 
            `${question.question.points}/${question.question.points}` : 
            `0/${question.question.points}`;
        } 
        
        // Preguntas de selección única (tipo 1)
        if (question.question.type === 1) {
          const answer = this.questionAnswers[index].answer;
          if (!answer) return `0/${question.question.points}`;
          
          return answer.isCorrect ?
            `${question.question.points}/${question.question.points}` : 
            `0/${question.question.points}`;
        }
        
        // Tipo de pregunta desconocido
        return `0/${question.question.points}`;
      } catch (e) {
        console.error('Error al calcular puntaje:', e);
        return `0/${question.question.points}`;
      }
    }
  },
  async created() {
    this.loading = true;
    
    try {
      const idActivity = this.$route.params.id;
      
      // Cargar respuestas
      const replyResponse = await axios.get("student/reply/" + idActivity);
      const { reply } = replyResponse.data;
      this.questionAnswers = JSON.parse(reply.answer);
      
      // Cargar actividad y preguntas
      const activityResponse = await axios.get("student/activity/" + idActivity);
      const { questions, reply: activityReply } = activityResponse.data;
      
      try {
        this.reply = JSON.parse(activityReply);
      } catch (e) {
        console.error('Error al parsear respuesta de actividad:', e);
        this.reply = [];
      }
      
      this.questions = questions;
    } catch (e) {
      console.error('Error al cargar datos:', e);
    } finally {
      this.loading = false;
    }
  },
};
</script>
